import { useEffect, useState } from 'react';
import { DateFilterField } from '../../../../../components/tables/filterForms/DateFilterField';
import { FilterField, FilterForm } from '../../../../../components/tables/filterForms/FilterForm';
import SFCTable from '../../../../../components/tables/SFCTable';
import { useToast } from '../../../../../context/ToastContext';
import { useListFiltersInUrl } from '../../../../../hooks';
import { useGetAllInstructorCourseRequestsQuery } from '../../../../../services/endpoints/schedule/instructorCourseRequest';
import { InstructorCourseRequest } from '../../../../../types/course.type';
import { instructorSessionRequestsColumns } from '../../../../../utils/consts/columnDefs/sessionColumns';
import { getFilterValue } from '../../../../../utils/listFilterSearchParams';

export const InstructorSessionRequestView = () => {
  const { addToast } = useToast();
  const [filters, setFilters] = useListFiltersInUrl(
    { scope: 'instructor_session_requests' },
    { omitScopeFromUrl: true }
  );
  const { data, error, isLoading, isFetching, refetch } =
    useGetAllInstructorCourseRequestsQuery(filters);
  const [requests, setRequests] = useState<InstructorCourseRequest[]>([]);

  const filterFormFields: FilterField[] = [
    {
      name: 'course_title',
      label: 'Session',
      value: getFilterValue(filters.data?.filterBy, 'course_title')
      // element: (
      //   <SearchField name="course_title" label="Session" placeholder="Search session" />
      // )
    },
    {
      name: 'instructor_full_name',
      label: 'Instructor',
      value: getFilterValue(filters.data?.filterBy, 'instructor_full_name')
      // element: (
      //   <SearchField name="instructor_full_name" label="Instructor" placeholder="Search instructor" />
      // )
    },
    {
      name: 'starts_from',
      id: 'created_at',
      operator: 'greater_equal_than',
      element: (
        <DateFilterField
          name="starts_from"
          label="Created At (From-To)"
        />
      ),
      value: getFilterValue(filters.data?.filterBy, 'created_at', 'greater_equal_than')
    },
    {
      name: 'starts_to',
      id: 'created_at',
      operator: 'lesser_equal_than',
      element: <DateFilterField name="starts_to" />,
      value: getFilterValue(filters.data?.filterBy, 'created_at', 'lesser_equal_than')
    }
  ];

  useEffect(() => {
    if (!isLoading && error) {
      addToast('Error while loading requests', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isLoading]);

  useEffect(() => {
    if (data && data.results) {
      setRequests(data.results);
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [filters, refetch]);
  const setFilterBy = (filterBy: { operator: string; field: string; value: string }[]) => {
    setFilters((prev) => ({
      ...prev,
      data: {
        ...prev?.data,
        filterBy
      }
    }));
  };

  return (
    <div className="py-2">
      <SFCTable
        name="Instructor Session Requests"
        columns={instructorSessionRequestsColumns}
        defaultScope={filters.scope ?? 'instructor_session_requests'}
        data={requests}
        count={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        filters={filters?.data?.filterBy}
        indexDownloadPath="instructor-course-requests"
        filterForm={
          <FilterForm
            fields={filterFormFields}
            onApplyFilters={setFilterBy}
          />
        }
        onFiltersChanged={setFilters}
      />
    </div>
  );
};
